import { Button, Card, Col, Descriptions, Row, Tag, Typography } from "antd";
import { useSelector } from "react-redux";
import { selectUser } from "redux/slices/userSlice";
import K from "utilities/constants";
import { convertIntoDashUSFormat } from "utilities/dateUtility";
import {
  displayUdfFieldValues,
  isPermissionPresent,
} from "utilities/generalUtility";

import { selectUdf } from "redux/slices/udfSlice";

const { Title } = Typography;

export default function ClientOverview({ clientData, setCurrentPage }) {
  const userSlice = useSelector(selectUser);
  const udfSlice = useSelector(selectUdf);

  const showClientEditInfoModal = () => {
    setCurrentPage(1);
  };

  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} md={24}>
        <Card
          title="Client Information"
          className="clientCard"
          bordered={false}
          extra={
            isPermissionPresent(K.Permissions.EditClient, userSlice.roles) && (
              <Button
                type="link"
                icon={<i className="icon-edit" />}
                onClick={() => showClientEditInfoModal(clientData)}
              />
            )
          }
        >
          <div className="cardContent">
            <div className="cardContentSecIcon">
              <div className="lockIcon">
                <i className="icon-lock cardContentIcon" />
              </div>
              <div className="lockIconText">
                <Title level={4}>Total Current Openings</Title>
                <p>{clientData?.totalOpenings}</p>
              </div>
            </div>
            <div className="cardContentItems">
              <Descriptions column={2}>
                <Descriptions.Item>Name</Descriptions.Item>
                <Descriptions.Item>
                  <Title level={5}>{clientData?.name}</Title>
                </Descriptions.Item>
                <Descriptions.Item>Original Contract Date</Descriptions.Item>
                <Descriptions.Item>
                  <Title level={5}>
                    {convertIntoDashUSFormat(
                      clientData?.originalContractDate,
                      false,
                    )}
                  </Title>
                </Descriptions.Item>
                <Descriptions.Item>Recruitment Started Date</Descriptions.Item>
                <Descriptions.Item>
                  <Title level={5}>
                    {convertIntoDashUSFormat(
                      clientData?.recruitmentStartedDate,
                      false,
                    )}
                  </Title>
                </Descriptions.Item>
                <Descriptions.Item>Corporate Address</Descriptions.Item>
                <Descriptions.Item>
                  <Title level={5}>
                    {clientData?.address ?? K.NullPlaceholder}
                  </Title>
                </Descriptions.Item>
                <Descriptions.Item>Website</Descriptions.Item>
                <Descriptions.Item>
                  <Title level={5}>
                    {clientData?.website ?? K.NullPlaceholder}
                  </Title>
                </Descriptions.Item>
                <Descriptions.Item>ATS</Descriptions.Item>
                <Descriptions.Item>
                  <Title level={5}>
                    {clientData?.ats?.name ?? K.NullPlaceholder}
                  </Title>
                </Descriptions.Item>
                <Descriptions.Item>Ownership</Descriptions.Item>
                <Descriptions.Item>
                  <Title level={5}>
                    {clientData?.ownership?.name ?? K.NullPlaceholder}
                  </Title>
                </Descriptions.Item>
                <Descriptions.Item>Client Service Leader</Descriptions.Item>
                <Descriptions.Item>
                  {clientData?.clientLeader ? (
                    <Tag level={5} color="#0070C0">
                      {clientData?.clientLeader?.name}
                    </Tag>
                  ) : (
                    <Title level={5}>{K.NullPlaceholder}</Title>
                  )}
                </Descriptions.Item>
                <Descriptions.Item>Account Manager</Descriptions.Item>
                <Descriptions.Item>
                  {clientData?.accountManagers.length ? (
                    clientData?.accountManagers.map((item) => (
                      <Tag color="#0070C0" key={item.id}>
                        {item.name}
                      </Tag>
                    ))
                  ) : (
                    <Title level={5}>{K.NullPlaceholder}</Title>
                  )}
                </Descriptions.Item>
                <Descriptions.Item>Client Success Leader</Descriptions.Item>
                <Descriptions.Item>
                  {clientData?.clientSuccessLeader?.name ? (
                    <Tag level={5} color="#0070C0">
                      {clientData?.clientSuccessLeader?.name}
                    </Tag>
                  ) : (
                    <Title level={5}>{K.NullPlaceholder}</Title>
                  )}
                </Descriptions.Item>
                <Descriptions.Item>Exclusivity</Descriptions.Item>
                <Descriptions.Item>
                  <Title level={5}>
                    {clientData?.exclusivity ?? K.NullPlaceholder}
                  </Title>
                </Descriptions.Item>
                <Descriptions.Item>Stage</Descriptions.Item>
                <Descriptions.Item>
                  <Title level={5}>{clientData?.stage?.name}</Title>
                </Descriptions.Item>
                <Descriptions.Item>Contact Persons</Descriptions.Item>
                <Descriptions.Item>
                  {clientData?.contacts.length ? (
                    clientData?.contacts.map(({ id, name }) => (
                      <Tag color="#0070C0" key={id}>
                        {name}
                      </Tag>
                    ))
                  ) : (
                    <Title level={5}>{K.NullPlaceholder}</Title>
                  )}
                </Descriptions.Item>
                {displayUdfFieldValues(udfSlice[K.Redux.ClientUdf]).map(
                  (item) => {
                    return (
                      <>
                        <Descriptions.Item>{item.label}</Descriptions.Item>
                        <Descriptions.Item>
                          <Title level={5}>
                            {item.value !== null && item.value !== ""
                              ? item.value
                              : "N/A"}
                          </Title>
                        </Descriptions.Item>
                      </>
                    );
                  },
                )}
              </Descriptions>
            </div>
          </div>
        </Card>
      </Col>
    </Row>
  );
}
